import React, { Component } from 'react'
import { Form, Grid, Image, Checkbox, Button, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import InputField from '../formComponents/inputField'
// import SelecTextField from '../formComponents/selectTextField'
// import { DropDown } from '../formComponents/dropDown'
// import Images from '../config/images'
import * as actionCreators from '../actions'
// import SearchFirmList from '../formComponents/searchFirmList'
import { bolAwbFields } from '../util/supportedFields/bolAwbForm'
import _, { get } from 'lodash'
import { saveContainer } from '../api/setFormData'
import PscHeaderReason from "./headerReason";
import { fetchSelectedReasonCodes, totalHeaderReasonSelected } from "../util";
//import {QryFuncModal} from '../../components/qryFunc';
// import { QryFuncModal } from 'kx-common-components';
export class ContainerizedShipmentForm extends Component {
  constructor() {
    super()
    this.state = {
      formInfo: {}
    }
    for (let key in bolAwbFields) {
      bolAwbFields[key].errors = []
      bolAwbFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.handleContainerSave.bind(this)
    this.addErrorIcon.bind(this)
    this.removeErrorIcon.bind(this)
  }

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName) : []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length > 0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' || get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }

  addErrorIcon(fieldName, value, msg) {
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = false
    bolAwbFields[fieldName].errors.push(msg)
    this.props.updateBolErrorWarning(1)
  }

  removeErrorIcon(fieldName, value) {
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = true
    this.props.updateBolErrorWarning(0)
  }

  // Check field Validity
  validateField(fieldName, value) {
    let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = true
    if (
      bolAwbFields[fieldName].rules &&
      bolAwbFields[fieldName].rules.length > 0
    ) {
      bolAwbFields[fieldName].rules.forEach(rule => {
        console.log(rule.test(value))
        if (!rule.test(value)) {
          bolAwbFields[fieldName].errors.push(rule.message)
          bolAwbFields[fieldName].valid = false
        }
      })
    }
    Object.keys(bolAwbFields).forEach(field => {
      if (!bolAwbFields[field].valid) {
        warning++
      }
    })
    this.props.updateBolErrorWarning(warning)
    if (bolAwbFields[fieldName].errors.length) {
      this.addErrorClass(fieldName, bolAwbFields)
    } else {
      this.removeErrorClass(fieldName, bolAwbFields)
    }
  }

  handleContainerSave(index, id, type, value, containerNumber) {
    saveContainer(id, type, value, containerNumber)
      .then(res => {
        let newContainerId = _.get(res, 'data.eventMessage.bolInfo.container[0].containerId', null)

        if (_.get(res, 'data.eventMessage.code') !== 200 && !newContainerId) {
          try {
            this.addErrorClass(`${type}${index}`)
            //let msg = 'Container number was invalid. The value was not saved, please amend.'
            this.addErrorIcon(`number${index}`, value, _.get(res, 'data.eventMessage.msg'))
          } catch (e) { }
        } else {
          try {
            this.removeErrorClass(`${type}${index}`)
            this.removeErrorIcon(`number${index}`, value)
          } catch (e) { }
        }
        // If a new contianer was saved, res will come with ID and we should resave it so UI is in sync
        if (newContainerId) {
          this.props.updateContainer(index, 'containerId', newContainerId)
        }
      })
  }

  addErrorClass(fieldName, fieldType) {
    console.log('fieldName1', fieldName)
    const inputField = document.getElementById(fieldName + window.shipmentId)
    inputField.classList.add('errorInput')
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      inputField.classList.remove('errorInput')
    } catch (e) {
      console.error(e)
    }
  }

  // Dispaly Errors
  displayValidationErrors = fieldName => {
    const field = bolAwbFields[fieldName]
    if (field && !field.valid) {
      const errors = field.errors.map((info, index) => {
        return (
          <span className='error' key={index}>
            * {info}
          </span>
        )
      })

      return <div style={{ position: 'absolute' }}>{errors}</div>
    }
    return null
  }
  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }
  render() {
    let {
      bolInfoValues,
      // updateBOLInfoField,
      updateContainer,
      removeAdditionalContainer,
      // saveBOLInfoField,
      // saveContainer,
      // manifestQuantityQuantity,
      // manifestQuantityUnits,
      // updateBOLObject,
      // updateTransportationField,
      // saveTransportationField,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      // unitList,
      // bolTypeList,
      // SCACList,
      // USportOfUnladingCode,
      // formDisabled,
      rbCounterID,
      // updateITDateField,
      isDisabled,
      addContainer,
      modeOfTransport,
      saveHeaderReason,
      // fieldValidation,
      engineBolInfo,
    } = this.props


    let pscWarningAlertShow = this.selectedReasons.length <= 0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' || get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')

    // let totalHeaderReasonSelected = this.props.pscData.headerCodes ? this.props.pscData.headerCodes.map((item)=>{
    //   return item.reasonCodes ? item.reasonCodes.length : 0
    // }).reduce((a, b) => a + b, 0) : 0;

    let isBlankTest = (input) => {
      if (!input) return true;
      if (input == "_BLANK_") return true;
      return false;
    }

    const columnNamesForTable = {
      "shipmentId": "Shipment",
      "masterBolNumber": "MBOL",
      "quantity": "Manifest QTY",
      "units": "UOM",
      "houseBolNumber": "HBOL",
      "itNumber": "In Bond",
      "itDate": "In Bond Date",
    };



    const showBolTable = (myEngineBolInfo) => {
      let columnNames = Object.keys(columnNamesForTable);

      return (<table style={{ width: '100%' }}>
        <thead>
          <tr>
            {columnNames.map(oneColumnName => <td style={{ padding: '1rem', whiteSpace: 'nowrap', border: '1px solid black' }} key={"foobar" + oneColumnName}>
              {columnNamesForTable[oneColumnName]}
            </td>)}
          </tr>
        </thead>
        <tbody>
          {(myEngineBolInfo?.engineBolRecord || []).map((oneRow, iii) => {

            return (<tr key={oneRow.manifestId + "kgkg" + oneRow.masterBolNumber + "kgkg"}>
              {columnNames.map(oneColumnName => <td style={{ border: '1px solid black', paddingLeft: '2px' }} key={oneRow.manifestId + "kgkg" + oneRow.masterBolNumber + "kgkg" + "foobar" + oneColumnName}>
                {oneRow[oneColumnName]}
              </td>)}


            </tr>)

          })}

        </tbody>

      </table>)
    }

    let isMasterBolModeNotHouse = bolInfoValues.bol.boltype !== 'HOUSE_BOL' && modeOfTransport != 'TRUCK' && isBlankTest(bolInfoValues.bol.bolHouseNumber);
    let truuck = modeOfTransport == "TRUCK";
      let accumulatorQuantityWeight = {quantity:0,weight:0};
      (bolInfoValues.container||[]).map((currentValue)=>{
        accumulatorQuantityWeight.quantity += parseInt(currentValue.quantity)||0;
        accumulatorQuantityWeight.weight += parseInt(currentValue.weight)||0;
        
    })
    return (
      <Form title={pscWarningAlertShow ? "Must select a PSC reason before you can edit" : ""}>
        {
          (get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) &&
          <PscHeaderReason
            {...this.props}
            pscState={get(this.props, "pscState.value.state")}
            totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
            selectedOptions={this.selectedReasons}
            saveHeaderReason={saveHeaderReason}
            enableDisableFrom={this.enableDisableFrom} />
        }
        <Grid width='equal' className='no-gutters'>




          <br />
          <React.Fragment>
            {bolInfoValues.container.map((container, index) => {
              let redundantContainerId = false;
              (bolInfoValues.container || []).forEach((existingcontainer, xindex) => {
                if ((existingcontainer.number + "").toLowerCase().trim() == (container.number + "").toLowerCase().trim() && xindex < index) {
                  redundantContainerId = true;
                }
              });

              return (

                <Grid.Row
                  key={index + '-' + container}
                  className='fourColoumnMerge blk1'
                >
                  <i
                    style={{ marginLeft: '15px', top: '10px' }}
                    className={
                      bolInfoValues.container.length === 1
                        ? 'trash alternate outline icon hide-element'
                        : 'trash alternate outline icon'
                    }
                    disabled={this.state.enableForm === true ? false : isDisabled("removeContainer")}
                    onClick={() => {
                      // if (formDisabled) {
                      //   return
                      // }
                      removeAdditionalContainer(index)
                    }}
                  />
                  <Grid.Column width={'4'} className='firstCol no-field-margin'>
                    <InputField
                      isLabel={false}
                      id={`number${index}`}
                      disabled={this.state.enableForm === true ? false : isDisabled("containerNo")}
                      type='text'
                      label='Container #'
                      labelClassName='city'
                      className='field-bg'
                      errors={_.get(bolAwbFields, `[number${index}].errors`, []).concat(redundantContainerId ? [`Duplicate Container Number '${container.number}'! Please only have one line per Container Number.`] : [])}
                      value={container.number}
                      onChange={value => {
                        updateContainer(index, 'number', value.replace(/[\W_]+/g, ""))
                      }}
                      onBlur={value => {
                        this.validateField(`number${index}`, value)
                        if (
                          bolAwbFields[`number${index}`] &&
                          bolAwbFields[`number${index}`].valid &&
                          !redundantContainerId
                        ) {
                          this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'number', value, value)
                        }
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                    {/* {this.displayValidationErrors(`number${index}`)} */}
                  </Grid.Column>
                  <Grid.Column width={'3'} className='secondCol no-field-margin'>
                    <InputField
                      // isLabel={false}
                      id={`size${index}`}
                      value={container.size}
                      className='field-bg'
                      labelClass='text-none'
                      label='Size'
                      disabled={
                        redundantContainerId || (
                          this.state.enableForm === true ? false : (isDisabled('containerSize')
                            || !bolAwbFields[`number${index}`]
                            || !bolAwbFields[`number${index}`].valid))}
                      errors={_.get(bolAwbFields, `[size${index}].errors`)}
                      onChange={value => {
                        updateContainer(index, 'size', value.replace(/[\W_]+/g, ""))
                      }}
                      onBlur={value => {
                        this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'size', value, container.number)
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                    {/* {this.displayValidationErrors(`size${index}`)} */}
                  </Grid.Column>
                  <Grid.Column width={'3'} className='thirdCol no-field-margin'>
                    <InputField
                      isLabel={false}
                      id={`sealNumber${index}`}
                      disabled={
                        redundantContainerId || (this.state.enableForm === true ? false : isDisabled("sealNumber"))
                      }
                      type='text'
                      label='Seal Number'
                      labelClassName='city'
                      className='field-bg'
                      errors={_.get(bolAwbFields, `[sealNumber${index}].errors`)}
                      value={container.sealNumber}
                      onChange={value => {
                        updateContainer(index, 'sealNumber', value)
                      }}
                      onBlur={value => {
                        this.validateField(`sealNumber${index}`, value)
                        if (
                          bolAwbFields[`sealNumber${index}`] &&
                          bolAwbFields[`sealNumber${index}`].valid
                        ) {
                          this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'sealNumber', value, container.number)
                        }
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                    {/* {this.displayValidationErrors(`number${index}`)} */}
                  </Grid.Column>
                  <Grid.Column width={'2'} className='thirdCol no-field-margin'>
                    <InputField
                      isLabel={false}
                      id={`quantity${index}`}
                      disabled={
                        redundantContainerId || (this.state.enableForm === true ? false : isDisabled("quantity"))
                      }
                      type='text'
                      label='Quantity'
                      labelClassName='city'
                      className='field-bg'
                      errors={_.get(bolAwbFields, `[quantity${index}].errors`)}
                      value={container.quantity}
                      onChange={value => {
                        updateContainer(index, 'quantity', value)
                      }}
                      onBlur={value => {
                        this.validateField(`quantity${index}`, value)
                        if (
                          bolAwbFields[`quantity${index}`] &&
                          bolAwbFields[`quantity${index}`].valid
                        ) {
                          this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'quantity', value, container.number)
                        }
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                    {/* {this.displayValidationErrors(`weight${index}`)} */}
                  </Grid.Column>
                  <Grid.Column width={'2'} className='lastCol no-field-margin'>
                    <InputField
                      isLabel={false}
                      id={`weight${index}`}
                      disabled={
                        redundantContainerId || (
                          this.state.enableForm === true ? false : isDisabled("weight")
                        )}
                      type='text'
                      label='Weight'
                      labelClassName='city'
                      className='field-bg'
                      errors={_.get(bolAwbFields, `[weight${index}].errors`)}
                      value={container.weight}
                      onChange={value => {
                        updateContainer(index, 'weight', value)
                      }}
                      onBlur={value => {
                        this.validateField(`weight${index}`, value)
                        if (
                          bolAwbFields[`weight${index}`] &&
                          bolAwbFields[`weight${index}`].valid
                        ) {
                          this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'weight', value, container.number)
                        }
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                    {/* {this.displayValidationErrors(`weight${index}`)} */}
                  </Grid.Column>
                </Grid.Row>
              )
            })}
            <Grid.Row 
                  className='fourColoumnMerge blk1'>
                  <i
                    style={{ marginLeft: '15px', top: '10px', visibility: 'hidden' }}
                    className={'trash alternate outline icon'
                    }
                  />
              
            <Grid.Column width={'10'}  className='thirdCol no-field-margin'>
                    <span style={{float:'right'}}>TOTALS:</span>
            </Grid.Column>
            <Grid.Column width={'2'}  className='thirdCol no-field-margin'>
            &nbsp;&nbsp;<b>{accumulatorQuantityWeight.quantity}</b> Count
            </Grid.Column>
            <Grid.Column width={'2'}  className='thirdCol no-field-margin'>
            &nbsp;&nbsp;<b>{accumulatorQuantityWeight.weight}</b> KG
            </Grid.Column>
            </Grid.Row>
          </React.Fragment>

          <Grid.Column>
            <Button style={{ display: 'none' }}></Button>
            <Button
              className={'add-line-item-btn add-cont'}
              basic
              color='blue'
              circular
              compact
              onClick={() => {
                // createContainer(bolInfoValues.container.length)
                addContainer({
                  number: "",
                  size: "",
                  containerId: ""
                })
              }}
              disabled={this.state.enableForm === true ? false : isDisabled('addContainer')}
            >
              <span>
                <Icon name='add circle' /> Add Additional Container
              </span>
            </Button>
          </Grid.Column>

        </Grid>
        <br />
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  bolInfoValues: state.BOLInfo,
  unitList: state.DropDownValues.unitList,
  bolTypeList: state.DropDownValues.bolTypeList,
  // SCACList: state.DropDownValues.SCACList,
  manifestQuantityQuantity: state.BOLInfo.manifestQuantity.quantity,
  manifestQuantityUnits: state.BOLInfo.manifestQuantity.units,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  shipmentId: state.FormValues.shipmentId,
  engineBolInfo: state.BOLInfo.engineBolInfo,
  USportOfUnladingCode: state.TransportationInfo.USportOfUnladingCode,
  formDisabled: state.FormValues.formDisabled,
  rbCounterID: state.FormValues.rbCounterID,
  fieldValidation: state.FieldValidation,
  tabName: "ContainerizedShipment",
  pscData: state.PSC
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContainerizedShipmentForm)
